import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['activateRecurrence', 'saveCreditCard', 'defaultCreditCard'];

  connect() {
    this.toggleSaveCreditCard();
    this.toggleActivateRecurrence();
  }

  toggleActivateRecurrence() {
    if (this.hasActivateRecurrenceTarget && this.activateRecurrenceTarget.checked) {
      this.saveCreditCardTarget.closest('.options-x').classList.add('hidden');
      this.saveCreditCardTarget.checked = true;

      this.defaultCreditCardTarget.closest('.options-x').classList.add('hidden');
      this.defaultCreditCardTarget.checked = true;
    } else {
      this.saveCreditCardTarget.closest('.options-x').classList.remove('hidden');
      this.saveCreditCardTarget.checked = false;

      this.defaultCreditCardTarget.closest('.options-x').classList.add('hidden');
      this.defaultCreditCardTarget.checked = false;
    }
  }

  toggleSaveCreditCard() {
    if (this.saveCreditCardTarget.checked) {
      this.defaultCreditCardTarget.closest('.options-x').classList.remove('hidden');
    } else {
      this.defaultCreditCardTarget.closest('.options-x').classList.add('hidden');
      this.defaultCreditCardTarget.checked = false;
    }
  }
}
